import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const LanguageSelector = ({ onOk }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState({ value: 'en', label: 'English', flag: '🇺🇸' });
    const dropdownRef = useRef(null);

    const options = [
        { value: 'English', label: 'English', flag: '🇺🇸', default: true },
        { value: 'Arabic', label: 'Arabic', flag: '🇸🇦' },
        { value: 'Español', label: 'Español', flag: '🇪🇸' },
        { value: 'Français', label: 'Français', flag: '🇫🇷' },
        { value: 'Deutsch', label: 'Deutsch', flag: '🇩🇪' },
        { value: 'Português', label: 'Português', flag: '🇵🇹' },
        { value: 'Zh-Hans', label: '中文', flag: '🇨🇳' }
    ];
    const lang = localStorage.getItem('languages') ?? 'English';    
    const filter = lang.split(",");   

    const normalizedFilter = filter.map(f => f.toLowerCase());
    const filteredOptions =
       filter.length > 0
        ? options.filter(opt =>
            normalizedFilter.includes(opt.value.toLowerCase()) || opt?.default == true
            )
        : options;

    // Close the dropdown if the user clicks anywhere outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative group" ref={dropdownRef}>
            {/* Custom Select Button */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between bg-white pl-4 pr-10 py-1 rounded-lg ring-1 ring-slate-200 text-xs font-bold text-slate-600 hover:ring-indigo-200 hover:bg-indigo-50 transition-all cursor-pointer shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
                <div className="flex items-center gap-2">
                    <span className="text-sm">{selected.flag}</span>
                    <span>{selected.label}</span>
                </div>
            </button>

            {/* Chevron Icon */}
            <div className="absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                <ChevronDown size={14} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </div>

            {/* Dropdown Menu Options */}
            {isOpen && (
                <div className="absolute top-full mt-2 left-0 w-full min-w-[140px] bg-white ring-1 ring-slate-200 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] z-50 overflow-hidden py-1 animate-in fade-in slide-in-from-top-2 duration-200">
                    {filteredOptions.map((option) => (
                        <button
                            key={option.value}
                            type="button"
                            onClick={() => {
                                setSelected(option);
                                setIsOpen(false);
                                onOk(option);
                                // Add your language change handler here if needed
                            }}
                            className={`w-full text-left px-4 py-2.5 text-xs font-bold flex items-center gap-2 hover:bg-indigo-50 hover:text-indigo-600 transition-colors ${
                                selected.value === option.value ? 'bg-indigo-50/50 text-indigo-600' : 'text-slate-600'
                            }`}
                        >
                            <span className="text-sm">{option.flag}</span>
                            <span>{option.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;